var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 252.203,
    height: 197.186,
    viewBox: "0 0 252.203 197.186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35 -45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77,99.514c11.589-19.7,26.654-25.5,42.878-24.336C126.831,58.953,138.42,52,151.168,52c15.065,0,24.336,6.953,30.131,16.224,10.039.3,14.419,8.1,13.756,16.173l-10.279,24.387H79.318C78.159,105.308,77,102.99,77,99.514Z",
    transform: "translate(1.243 -7)",
    fill: "#fdc149"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 83.243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,103H189.382",
    transform: "translate(-38.729 -74.028)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.271,103,40,152.831l42.966,17.013",
    transform: "translate(-40 -74.028)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,78h62.579",
    transform: "translate(-17.441 -78)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.878,78,145,195.046",
    transform: "translate(-23.319 -78)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.426,129.325H200.459V94.51c4.621,0,15.613-.074,21.269,0,4.359,0,34.983,4,34.983,34.815v63.1",
    transform: "translate(-14.508 -75.382)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,179h15.065",
    transform: "translate(-8.862 -61.954)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.748,181.737A12.861,12.861,0,0,1,48,168.99v-7.219",
    transform: "translate(-42.206 -64.692)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.878 128.439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.43,124,104,151.813",
    transform: "translate(-72.711 -124)",
    fill: "none",
    stroke: "#fdc149",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43,124,104,151.813",
    transform: "translate(-44.711 -124)",
    fill: "none",
    stroke: "#fdc149",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43,124,104,151.813",
    transform: "translate(-100.711 -124)",
    fill: "none",
    stroke: "#fdc149",
    strokeLinecap: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.448 172.476)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(0.153 -0.289)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(123.153 -0.289)",
    fill: "none",
    stroke: "#1a1a2e",
    strokeWidth: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.59bfde188e1ac94ec072988798ec91fd.svg";
export { ForwardRef as ReactComponent };